import { onBeforeUnmount, ref } from 'vue'

export function useCourseScheduleJob(api, workspaceId, onFinished) {
  const activeJob = ref(null)
  let timer = null

  const stopPolling = () => {
    if (timer) clearInterval(timer)
    timer = null
  }

  const poll = async () => {
    if (!activeJob.value?.id) return
    const job = await api.getJob(workspaceId, activeJob.value.id)
    activeJob.value = job
    if (!['queued', 'running'].includes(job.status)) {
      stopPolling()
      await onFinished?.(job)
    }
  }

  const startPolling = (job) => {
    activeJob.value = job
    stopPolling()
    timer = setInterval(() => poll().catch(stopPolling), 1500)
    poll().catch(stopPolling)
  }

  onBeforeUnmount(stopPolling)

  return { activeJob, startPolling, stopPolling, poll }
}
